import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import ProductSubgroup from '../../models/ProductSubgroup'

export interface ProductSubgroupListState extends PaginatedApiState {
  productSubgroups?: ProductSubgroup[] 
}

const ProductSubgroupList = (state: ProductSubgroupListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<ProductSubgroupListState>('PRODUCTSUBGROUP_LIST')(state, action)
  }
}

export default ProductSubgroupList
